module.exports = __webpack_public_path__ + "static/media/sample2.540efb8a.jpg";